// You can write more code here

/* START OF COMPILED CODE */

import Checkbox from "../GeneralUI/Checkbox";
/* START-USER-IMPORTS */
import { SettingToggleController } from '@/game/prefabs/SettingToggle/SettingToggleController';
/* END-USER-IMPORTS */

export default class SettingToggle extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// checkbox
		const checkbox = new Checkbox(scene, 0, 0);
		this.add(checkbox);

		// settingLabel
		const settingLabel = scene.add.bitmapText(40, 0, "Aronui", "Setting 1");
		settingLabel.setOrigin(0, 0.5);
		settingLabel.tintTopLeft = 5387071;
		settingLabel.tintTopRight = 5387071;
		settingLabel.tintBottomLeft = 5387071;
		settingLabel.tintBottomRight = 5387071;
		settingLabel.text = "Setting 1";
		settingLabel.fontSize = -24;
		settingLabel.maxWidth = 180;
		this.add(settingLabel);

		// tooltipDisabledCover
		const tooltipDisabledCover = scene.add.image(-32, 0, "1x1sprite");
		tooltipDisabledCover.setInteractive(new Phaser.Geom.Rectangle(0, 0, 1, 1), Phaser.Geom.Rectangle.Contains);
		tooltipDisabledCover.scaleX = 500;
		tooltipDisabledCover.scaleY = 64;
		tooltipDisabledCover.setOrigin(0, 0.5);
		tooltipDisabledCover.alpha = 0.0001;
		tooltipDisabledCover.alphaTopLeft = 0.0001;
		tooltipDisabledCover.alphaTopRight = 0.0001;
		tooltipDisabledCover.alphaBottomLeft = 0.0001;
		tooltipDisabledCover.alphaBottomRight = 0.0001;
		this.add(tooltipDisabledCover);

		// settingTooltip
		const settingTooltip = scene.add.container(192, -32);
		settingTooltip.visible = false;
		this.add(settingTooltip);

		// tooltipBacking
		const tooltipBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 116, 32, 10, 10, 10, 10);
		tooltipBacking.scaleX = 4;
		tooltipBacking.scaleY = 4;
		tooltipBacking.setOrigin(0, 0);
		settingTooltip.add(tooltipBacking);

		// tooltipText
		const tooltipText = scene.add.bitmapText(80, 12, "Aronui", "Explanation of what this setting does.");
		tooltipText.tintTopLeft = 5387071;
		tooltipText.tintTopRight = 5387071;
		tooltipText.tintBottomLeft = 5387071;
		tooltipText.tintBottomRight = 5387071;
		tooltipText.text = "Explanation of what this setting does.";
		tooltipText.fontSize = -24;
		tooltipText.maxWidth = 386;
		settingTooltip.add(tooltipText);

		// helpIcon
		const helpIcon = scene.add.image(40, 64, "help3");
		helpIcon.scaleX = 4;
		helpIcon.scaleY = 4;
		settingTooltip.add(helpIcon);

		// interactionHitbox
		const interactionHitbox = scene.add.image(28, -32, "1x1sprite");
		interactionHitbox.scaleX = 200;
		interactionHitbox.scaleY = 64;
		interactionHitbox.setOrigin(0, 0);
		interactionHitbox.alpha = 0.0001;
		interactionHitbox.alphaTopLeft = 0.0001;
		interactionHitbox.alphaTopRight = 0.0001;
		interactionHitbox.alphaBottomLeft = 0.0001;
		interactionHitbox.alphaBottomRight = 0.0001;
		this.add(interactionHitbox);

		this.checkbox = checkbox;
		this.settingLabel = settingLabel;
		this.tooltipDisabledCover = tooltipDisabledCover;
		this.tooltipBacking = tooltipBacking;
		this.tooltipText = tooltipText;
		this.helpIcon = helpIcon;
		this.settingTooltip = settingTooltip;
		this.interactionHitbox = interactionHitbox;

		/* START-USER-CTR-CODE */

    this._controller = new SettingToggleController(this);
    /* END-USER-CTR-CODE */
	}

	public checkbox: Checkbox;
	public settingLabel: Phaser.GameObjects.BitmapText;
	public tooltipDisabledCover: Phaser.GameObjects.Image;
	public tooltipBacking: Phaser.GameObjects.NineSlice;
	public tooltipText: Phaser.GameObjects.BitmapText;
	public helpIcon: Phaser.GameObjects.Image;
	public settingTooltip: Phaser.GameObjects.Container;
	public interactionHitbox: Phaser.GameObjects.Image;
	public maxWidth: number = 500;

	/* START-USER-CODE */

  public key: string = '';
  public _controller: SettingToggleController;
  get controller() {
    return this._controller;
  }
  public enableTooltip: boolean = true;

  setMaxWidth(newMaxWidth: number) {
    this.maxWidth = newMaxWidth;
    this.tooltipDisabledCover.scaleX = newMaxWidth;
    this.settingLabel.maxWidth = newMaxWidth;
    this.interactionHitbox.scaleX = newMaxWidth;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
